import { TThunkAction } from '../../types/redux';
import { validateFilters } from '@cian/valuation-main-filters-widget';
import { checkEstimationExistsRequest, checkEstimationExistsRequestError, resetCheckEstimationExists } from './actions';

import {
  fetchCheckEstimationExists,
  ICheckEstimationExistsResponse200,
  ICheckEstimationExistsResponse400,
} from '../../repositories/price-estimator/v1/check-estimation-exists';
import {
  fetchGetEstimationSuburban,
  IGetEstimationSuburbanResponse200 as ISuburbanRes200,
  IGetEstimationSuburbanResponse400 as ISuburbanRes400,
} from '../../repositories/price-estimator/v1/get-estimation-suburban';
import { mapEstimationTargetToECategory } from '../../constants/filters';

export const checkEstimationExists = (): TThunkAction<Promise<boolean>> => {
  return async (dispatch, getState, context) => {
    dispatch(checkEstimationExistsRequest());

    const isFormValid = await dispatch(validateFilters() as unknown as TThunkAction<Promise<boolean>>);

    if (!isFormValid) {
      dispatch(resetCheckEstimationExists());

      return false;
    }

    /**
     * houseId появится только после валидации
     * поэтому getState стоит вызывать уже после валидации
     */
    const {
      filters: { roomsCount, area, houseId },
    } = getState();
    const { httpApi, logger } = context;

    try {
      const res = await fetchCheckEstimationExists<
        ICheckEstimationExistsResponse200,
        ICheckEstimationExistsResponse400
      >({
        httpApi,
        parameters: {
          houseId: houseId as number,
          roomsCount: roomsCount as number,
          area: area as number,
        },
      });

      if (res.statusCode === 200 && res.response.exists) {
        return true;
      }

      dispatch(checkEstimationExistsRequestError());

      return false;
    } catch (e) {
      logger.error(e, { message: 'Unable to check estimation exists' });
      dispatch(checkEstimationExistsRequestError());

      return false;
    }
  };
};

export const checkSuburbanEstimationExists = (): TThunkAction<Promise<boolean>> => {
  return async (dispatch, getState, context) => {
    dispatch(checkEstimationExistsRequest());

    const isFormValid = await dispatch(validateFilters() as unknown as TThunkAction<Promise<boolean>>);

    if (!isFormValid) {
      dispatch(resetCheckEstimationExists());

      return false;
    }

    const {
      filters: { address, houseArea, landArea, estimationTarget },
    } = getState();
    const { httpApi, logger } = context;

    try {
      const res = await fetchGetEstimationSuburban<ISuburbanRes200, ISuburbanRes400>({
        httpApi,
        parameters: {
          address,
          houseArea,
          landArea: landArea as number,
          category: mapEstimationTargetToECategory[estimationTarget],
        },
      });

      if (res.statusCode === 200 && res.response.sale) {
        return true;
      }

      dispatch(checkEstimationExistsRequestError());

      return false;
    } catch (e) {
      logger.error(e, { message: 'Unable to check suburban estimation exists' });
      dispatch(checkEstimationExistsRequestError());

      return false;
    }
  };
};
